import './index.scss';

import { Rive } from '@rive-app/canvas-lite';

class Canvas {
    constructor(root) {
        this.root = root;
        this.rive = new Rive({
            canvas: this.root,
            src: this.root.dataset.src,
            onLoad: () => {
                this.rive.resizeDrawingSurfaceToCanvas();
            },
        });

        if (this.root.classList.contains('auto')) {
            this.rive.play();
        } else {
            this.root.addEventListener('mouseenter', (event) => {
                if (this.rive.animationNames.includes('on')) {
                    if (this.rive.isPlaying) {
                        this.rive.stop();
                    }

                    this.rive.play('on');
                }
            });

            this.root.addEventListener('mouseleave', (event) => {
                if (this.rive.animationNames.includes('off')) {
                    if (this.rive.isPlaying) {
                        this.rive.stop();
                    }

                    this.rive.play('off');
                }
            });
        }

        // window.addEventListener('resize', () => {
        //     this.rive.resizeDrawingSurfaceToCanvas();
        // });
    }
}

window.app.run(() => {
    document.querySelectorAll('canvas.rive').forEach((node) => {
        new Canvas(node);
    });
});
